
import SpeedkitPicture from '#speedkit/components/SpeedkitPicture'

export default {
  name: 'Features',
  components: {
    SpeedkitPicture,
  },
  props: {
    features: {
      type: Array,
      require: false,
    },
  },
}
